import { createContext, useContext } from "react";

/**
 * Whether what is being rendered is already inside a bottom sheet.
 *
 * Only one thing asks: a picker opened from inside a sheet cannot be another
 * sheet. Two of them stack at the same edge of the same screen, the lower one
 * dimming and half-covering the panel it belongs to, and what the reader is
 * left looking at is two competing surfaces with the question on the one that
 * has gone grey. So a picker inside a sheet takes the screen instead — see
 * `takeover` in `CustomDropdown`.
 *
 * A context rather than a prop because nothing in between would pass it on: a
 * dropdown three levels down a form has no idea what its screen is, and every
 * component between it and the sheet would have to carry a flag that is none
 * of its business.
 *
 * False outside a sheet, which is every other screen in the app.
 */
export const InsideSheetContext = createContext(false);

/** True while the caller is being rendered inside a `BottomSheet`. */
export const useInsideSheet = (): boolean => useContext(InsideSheetContext);
